import React from 'react';
import PropTypes from 'prop-types';

const InfoIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 30 30">
        <path d="M15 2.5A12.5 12.5 0 112.5 15 12.514 12.514 0 0115 2.5zM15 0a15 15 0 1015 15A15 15 0 0015 0zm1.25 22.5h-2.5v-10h2.5zM15 7.188a1.563 1.563 0 11-1.562 1.562A1.563 1.563 0 0115 7.188z" fill={fill} />
    </svg>
);

InfoIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

InfoIcon.defaultProps = {
    width: '30',
    height: '30',
    fill: '#fff'
};

export default InfoIcon;
